module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg5.bc205890.png";